// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"3237c117","108":"d8a23ccb","312":"e2214c18","360":"7f8131c1","416":"709e8978","459":"807dbd1e","477":"4227a26c","568":"ce6cd91c","592":"e42b3028","728":"1736f60a","840":"04dd3aa3"}[chunkId] + ".chunk.js";
};